import call from "./call";
import {
  LoginInfoResponse,
  User,
  UserMemoryResponse,
  UserResponse,
} from "../Models/user";

export const updateUser = async (
  name: string,
  surname: string,
  email?: string,
) => {
  const response = await call.put(
    "/v1/user/edit/",
    {
      name: name,
      ...(email && { email }),
      surname: surname,
    },
    {
      snack: {
        success: "user.updateSuccess",
        error: "user.updateError",
      },
    },
  );
  return response;
};

export const changePassword = async (
  currentPassword: string,
  newPassword: string,
) => {
  const response = await call.put(
    "/v1/user/change-password/",
    {
      current_password: currentPassword,
      new_password: newPassword,
    },
    {
      snack: {
        success: "user.passwordChangeSuccess",
        error: "user.passwordChangeError",
      },
    },
  );
  return response;
};

export const getUsers = async (
  page: number = 1,
  page_size: number = 10,
  search: string = "",
  workspace?: number,
  sort_order?: string,
  sort_direction?: "asc" | "desc",
): Promise<UserResponse> => {
  const response = await call.get("/v1/user/users/", {
    params: {
      page,
      page_size,
      search,
      workspace,
      sort_order,
      sort_direction,
    },
    snack: {
      error: "user.fetchUsersError",
    },
  });
  return response.data;
};

export const createUser = async (
  name: string,
  surname: string,
  password: string | null,
  email: string,
  evaluation_limit: number,
  max_companies: number,
  model_ids: number[],
  storage_limit: number,
  library_limit: number,
  cert_category_ids: number[],
  is_sso: boolean,
  workspace_id: number | null,
  features: number[],
  experts: string[],
  show_locked_features: boolean,
  agent_ids: number[] = [],
) => {
  const response = await call.post(
    "/v1/user/register/",
    {
      name,
      surname,
      password,
      email,
      evaluation_limit,
      companies_limit: max_companies,
      model_ids,
      storage_limit,
      library_limit,
      cert_category_ids,
      is_sso,
      workspace_id,
      features,
      experts,
      show_locked_features,
      agent_ids,
    },
    {
      snack: {
        success: "user.createSuccess",
        error: "user.createError",
      },
    },
  );
  return response;
};

export const editUserById = async (
  userId: string,
  name: string,
  surname: string,
  email: string,
  evaluation_limit: number,
  companies_limit: number,
  password: string,
  model_ids: number[],
  cert_category_ids: number[],
  workspace_id: number | null,
  features: number[],
  experts: string[],
  storage_limit: number,
  library_limit: number,
  show_locked_features: boolean,
  agent_ids: number[] = [],
) => {
  const response = await call.put(
    `/v1/user/${userId}/`,
    {
      name,
      surname,
      email,
      evaluation_limit,
      companies_limit,
      password,
      model_ids,
      cert_category_ids,
      workspace_id,
      features,
      experts,
      storage_limit,
      library_limit,
      show_locked_features,
      agent_ids,
    },
    {
      snack: {
        success: "user.updateByIdSuccess",
        error: "user.updateByIdError",
      },
    },
  );
  return response;
};

export const getUserById = async (userId: string): Promise<User> => {
  const response = await call.get(`/v1/user/${userId}/`);
  return response.data;
};

export const getMySelf = async (): Promise<User> => {
  const response = await call.get("/v1/user/");
  return response.data;
};

export const deleteUserById = async (userId: string) => {
  const response = await call.delete(`/v1/user/${userId}/`, {
    snack: {
      success: "user.deleteSuccess",
      423: "user.deleteLockedError",
      error: "user.deleteError",
    },
  });
  return response;
};

export const getAlanQuota = async () => {
  const response = await call.get("/v1/user/alan-quota/");
  return response.data;
};

export const getLoginInfoByUserId = async (
  userId: string,
): Promise<LoginInfoResponse> => {
  const response = await call.get(`/v1/login_info/users/${userId}/`, {
    snack: {
      error: "user.fetchLoginInfoError",
    },
  });

  return response.data;
};

export const toggleUserDisabled = async (userId: string) => {
  const response = await call.put(
    `/v1/user/toggle_user_disabled/${userId}/`,
    {},
    {
      snack: {
        success: "user.toggleDisabledSuccess",
        error: "user.toggleDisabledError",
      },
    },
  );
  return response;
};

export const getUserMemory = async (): Promise<UserMemoryResponse> => {
  const response = await call.get("/v1/user_memory/");
  return response.data;
};

export const updateUserMemory = async (
  line: number,
  text: string,
  expected: string,
): Promise<UserMemoryResponse> => {
  const response = await call.put(`/v1/user_memory/${line}/`, {
    text,
    expected,
  });

  return response.data;
};

export const deleteUserMemory = async (
  line: number,
  expected: string,
): Promise<UserMemoryResponse> => {
  const response = await call.delete(`/v1/user_memory/${line}/`, {
    params: {
      expected,
    },
  });

  return response.data;
};

export const clearUserMemory = async (): Promise<UserMemoryResponse> => {
  const response = await call.delete("/v1/user_memory/");
  return response.data;
};
